export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  NodeValue: any;
};

export type ActionConfig = {
  contentTypeGroups?: Maybe<Array<Scalars['String']>>;
  type: Scalars['String'];
};

export enum AdditionalInfoFieldType {
  Boolean = 'boolean',
  Number = 'number',
  Text = 'text'
}

export type AdditionalInfoInput = {
  fieldCode?: InputMaybe<Scalars['String']>;
  fieldName?: InputMaybe<Scalars['String']>;
  fieldType?: InputMaybe<AdditionalInfoFieldType>;
  jsonDataFormula?: InputMaybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  showOnLinkTable: Scalars['Boolean'];
};

export type AdditionalInfoType = {
  fieldCode?: Maybe<Scalars['String']>;
  fieldName?: Maybe<Scalars['String']>;
  fieldType?: Maybe<AdditionalInfoFieldType>;
  jsonDataFormula?: Maybe<Scalars['String']>;
  readonly: Scalars['Boolean'];
  showOnLinkTable: Scalars['Boolean'];
};

export type AlignModelGlsResponse = {
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
  successfullyUpdatedGls: Array<Scalars['String']>;
};

export type AttachmentsParams = {
  authUrl: Scalars['String'];
  baseUrl: Scalars['String'];
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  linkParameter: Scalars['String'];
  scope: Scalars['String'];
  sharepointBaseLink: Scalars['String'];
};

export type BoomiParams = {
  authUrl: Scalars['String'];
  baseUrl: Scalars['String'];
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  commonXApiKey: Scalars['String'];
  scope: Scalars['String'];
  zeusXApiKey: Scalars['String'];
};

export type BreadcrumbNode = {
  code: Scalars['String'];
  id: Scalars['String'];
  listName?: Maybe<Scalars['String']>;
};

export type BuildUpDiff = {
  familyId: Scalars['String'];
  prototypes: Array<BuildUpDiffPrototype>;
};

export type BuildUpDiffPrototype = {
  fields: Array<BuildUpDiffPrototypeField>;
  prototypeCode: Scalars['String'];
  prototypeId: Scalars['String'];
};

export type BuildUpDiffPrototypeField = {
  certified?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  draft?: Maybe<Scalars['String']>;
};

export type BulkNodeContent = {
  children?: InputMaybe<Array<BulkNodeContent>>;
  code: Scalars['String'];
  contents: Array<NodeContent>;
  parent: Scalars['String'];
};

export type BulkNodes = {
  contents: Array<NodeContent>;
  node: Scalars['String'];
};

export type CertificationResponse = {
  documentId?: Maybe<Scalars['String']>;
  salesforceDocumentId?: Maybe<Scalars['String']>;
};

export type CertificationStatus = {
  certified: Scalars['String'];
  certifiedDraft: Scalars['String'];
  certifiedError: Scalars['String'];
  certifiedInCertification: Scalars['String'];
  certifiedPublished: Scalars['String'];
  draft: Scalars['String'];
  error: Scalars['String'];
  inCertification: Scalars['String'];
};

export type CgtModelVariables = {
  base_program: Scalars['Float'];
  biased: Scalars['Float'];
  c1: Scalars['Float'];
  c2: Scalars['Float'];
  c3: Scalars['Float'];
  cash_discount: Scalars['Float'];
  cgtModelId: Scalars['String'];
  conquest: Scalars['Float'];
  cva: Scalars['Float'];
  dealer_discount: Scalars['Float'];
  extra_value_support: Scalars['Float'];
  incentive_volume: Scalars['Float'];
  lc: Scalars['Float'];
  sv: Scalars['Float'];
};

export type CgtSettings = {
  attachmentsParams?: Maybe<AttachmentsParams>;
  boomiParams?: Maybe<BoomiParams>;
  catImportNotificationEmails?: Maybe<Array<Scalars['String']>>;
  coolsalesExporter: CoolsalesExporter;
  disableChangeParentHierarchy?: Maybe<Array<Scalars['String']>>;
  disableCreateFromHierarchy?: Maybe<Array<Scalars['String']>>;
  discountMPRoles: Array<DiscountMpRoles>;
  enableReplaceLinkHierarchy?: Maybe<Array<Scalars['String']>>;
  exporter: Exporter;
  fields: FieldsSetting;
  forceCertificateButtonActive: Scalars['Boolean'];
  glMediaCategoryMapping?: Maybe<GlMediaCategoryMapping>;
  groups: GroupsSetting;
  hideFavorite?: Maybe<Scalars['Boolean']>;
  hierarchies: HierarchiesSetting;
  hintoParams?: Maybe<HintoParams>;
  listiniPerZMABCode: Scalars['String'];
  manodoperaSupplierId: Scalars['String'];
  microsoftGraphParams?: Maybe<MicrosoftGraphParams>;
  objectSchemas: ObjectSchemasSetting;
  paths: PathsSetting;
  pricelistCatNodeCode: Scalars['String'];
  prototypeMediaCategoryMapping?: Maybe<PrototypeMediaCategoryMapping>;
  prototypeSetting: PrototypeSetting;
  showNodeStatuses: Scalars['Boolean'];
  skipCertificate: Scalars['Boolean'];
  skipExport: Scalars['Boolean'];
  skipHinto: Scalars['Boolean'];
  skipKeyFeature: Scalars['Boolean'];
  skipPublish: Scalars['Boolean'];
  skipStatus: Scalars['Boolean'];
  skipTechData: Scalars['Boolean'];
  useDynamicRules?: Maybe<Scalars['Boolean']>;
};

export type CheckResponse = {
  codes?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ClientConfig = {
  clientId: Scalars['String'];
  endpoint: Scalars['String'];
  listId: Scalars['String'];
  secret: Scalars['String'];
};

export type ClientConfigInput = {
  clientId: Scalars['String'];
  endpoint: Scalars['String'];
  listId: Scalars['String'];
  secret: Scalars['String'];
};

export type CompatiblePriceList = {
  compatibilePriceLists?: Maybe<Array<PriceListInfo>>;
  compatibilePriceListsZMAB?: Maybe<Array<PriceListInfo>>;
  disabledPriceListId?: Maybe<Scalars['String']>;
};

export type ContentType = {
  additionalInfo?: Maybe<Array<Maybe<AdditionalInfoType>>>;
  allowDuplicateOptionsCode?: Maybe<Scalars['Boolean']>;
  autoFilled?: Maybe<Scalars['Boolean']>;
  client?: Maybe<ClientConfig>;
  code: Scalars['String'];
  columnSize?: Maybe<Scalars['String']>;
  compactView?: Maybe<Scalars['Boolean']>;
  creatable?: Maybe<Scalars['Boolean']>;
  defaultValueExpression?: Maybe<Scalars['String']>;
  depthFilter?: Maybe<Scalars['String']>;
  disableEditAction?: Maybe<Scalars['Boolean']>;
  disableNodeCreation?: Maybe<Scalars['Boolean']>;
  dynamicFilters?: Maybe<Array<Filters>>;
  dynamicReadonly?: Maybe<DynamicReadonly>;
  dynamicRegex?: Maybe<Array<DynamicRegex>>;
  enableRange?: Maybe<Scalars['Boolean']>;
  filters?: Maybe<Array<Filters>>;
  hidden?: Maybe<Scalars['Boolean']>;
  hierarchy?: Maybe<Scalars['String']>;
  isMainImage?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<Scalars['String']>;
  link?: Maybe<Array<Maybe<Scalars['String']>>>;
  mandatory: Scalars['Boolean'];
  mandatoryForSave?: Maybe<MandatoryForSaveCondition>;
  multiLanguage: Scalars['Boolean'];
  multiLine?: Maybe<Scalars['Boolean']>;
  multiValue: Scalars['Boolean'];
  name: Array<NameObject>;
  optionalValues?: Maybe<Array<SelectOptionValues>>;
  readOnly?: Maybe<Scalars['Boolean']>;
  regex?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  showAsPercentage?: Maybe<Scalars['Boolean']>;
  showCode?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  viewRoles?: Maybe<Array<Scalars['String']>>;
  visibility?: Maybe<Visibility>;
  workflowCode?: Maybe<Scalars['String']>;
};

export type ContentTypeGroup = {
  approveRoles?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  collapsed?: Maybe<Scalars['Boolean']>;
  contentTypes?: Maybe<Array<ContentType>>;
  name: Array<NameObject>;
  repeatable: Scalars['Boolean'];
  roles?: Maybe<Scalars['String']>;
  showLevel?: Maybe<Scalars['String']>;
  viewRoles?: Maybe<Array<Scalars['String']>>;
};

export type ContentTypeGroupI = {
  approveRoles?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  collapsed: Scalars['Boolean'];
  name: Array<NameObjectI>;
  repeatable: Scalars['Boolean'];
  roles?: InputMaybe<Scalars['String']>;
  showLevel?: InputMaybe<Scalars['String']>;
  viewRoles?: InputMaybe<Array<Scalars['String']>>;
};

export type ContentTypeGroupStatus = {
  code: Scalars['String'];
  publishedAt?: Maybe<Scalars['String']>;
  status: CtgStatus;
};

export type ContentTypeInput = {
  additionalInfo?: InputMaybe<Array<AdditionalInfoInput>>;
  allowDuplicateOptionsCode?: InputMaybe<Scalars['Boolean']>;
  autoFilled?: InputMaybe<Scalars['Boolean']>;
  client?: InputMaybe<ClientConfigInput>;
  code: Scalars['String'];
  columnSize?: InputMaybe<Scalars['String']>;
  compactView?: InputMaybe<Scalars['Boolean']>;
  creatable?: InputMaybe<Scalars['Boolean']>;
  defaultValueExpression?: InputMaybe<Scalars['String']>;
  depthFilter?: InputMaybe<Scalars['String']>;
  disableEditAction?: InputMaybe<Scalars['Boolean']>;
  disableNodeCreation?: InputMaybe<Scalars['Boolean']>;
  dynamicFilters?: InputMaybe<Array<FiltersInput>>;
  dynamicReadonly?: InputMaybe<DynamicReadonlyInput>;
  dynamicRegex?: InputMaybe<Array<DynamicRegexInput>>;
  enableRange: Scalars['Boolean'];
  filters?: InputMaybe<Array<FiltersInput>>;
  hidden: Scalars['Boolean'];
  hierarchy?: InputMaybe<Scalars['String']>;
  isMainImage?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Array<Scalars['String']>>;
  mandatory: Scalars['Boolean'];
  mandatoryForSave?: InputMaybe<MandatoryForSaveConditionInput>;
  multiLanguage: Scalars['Boolean'];
  multiLine?: InputMaybe<Scalars['Boolean']>;
  multiValue: Scalars['Boolean'];
  name: Array<NameObjectI>;
  optionalValues?: InputMaybe<Array<SelectOptionValuesInput>>;
  readOnly: Scalars['Boolean'];
  regex?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  showAsPercentage?: InputMaybe<Scalars['Boolean']>;
  showCode?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
  viewRoles?: InputMaybe<Array<Scalars['String']>>;
  visibility: VisibilityInput;
  workflowCode?: InputMaybe<Scalars['String']>;
};

export type CoolsalesExporter = {
  couch: Couch;
};

export type Couch = {
  dbName: Scalars['String'];
  dbUri: Scalars['String'];
  globalDbName: Scalars['String'];
};

export type CpqDiscountLimits = {
  maxPercentage: Scalars['Float'];
  roleOverrides?: Maybe<Array<CpqRoleOverride>>;
};

export type CpqHierarchies = {
  lineItems: Scalars['String'];
  offers: Scalars['String'];
  sections: Scalars['String'];
};

export type CpqOfferNumberFormat = {
  includeYear: Scalars['Boolean'];
  prefix: Scalars['String'];
  sequenceLength: Scalars['Int'];
};

export type CpqRoleOverride = {
  maxPercentage: Scalars['Float'];
  role: Scalars['String'];
};

export type CpqSettings = {
  defaultTaxRate?: Maybe<Scalars['Float']>;
  defaultValidityDays?: Maybe<Scalars['Int']>;
  discountLimits?: Maybe<CpqDiscountLimits>;
  enable: Scalars['Boolean'];
  hierarchies: CpqHierarchies;
  lineItemColumns?: Maybe<Array<PrototypeContentType>>;
  offerInfoContentTypeGroups?: Maybe<Array<Scalars['String']>>;
  offerNumberFormat?: Maybe<CpqOfferNumberFormat>;
  readonlyStatuses?: Maybe<Array<Scalars['String']>>;
  workflowStatusContentType?: Maybe<PrototypeContentType>;
};

export type CrmHierarchies = {
  accounts: Scalars['String'];
  activities: Scalars['String'];
  contacts: Scalars['String'];
  leads: Scalars['String'];
  opportunities: Scalars['String'];
};

export type CrmPipeline = {
  stages: Array<CrmPipelineStage>;
};

export type CrmPipelineStage = {
  code: Scalars['String'];
  label: Scalars['String'];
  order: Scalars['Int'];
  probability: Scalars['Float'];
};

export type CrmSettings = {
  enable: Scalars['Boolean'];
  hierarchies: CrmHierarchies;
  pipeline: CrmPipeline;
  staleLeadDays?: Maybe<Scalars['Int']>;
  workflowStatusContentType?: Maybe<PrototypeContentType>;
};

export enum CtgStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  NotPublishable = 'NOT_PUBLISHABLE',
  Published = 'PUBLISHED',
  PublishedDraft = 'PUBLISHED_DRAFT'
}

export type CustomPage = {
  detailLayout: CustomPageLayout;
  filter?: Maybe<CustomPageFilter>;
  hierarchyId: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  listLayout: CustomPageLayout;
  name: Scalars['String'];
  objectSchemaCode?: Maybe<Scalars['String']>;
  requiredRole?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type CustomPageColumn = {
  widgets: Array<CustomPageWidget>;
  width?: Maybe<Scalars['String']>;
};

export type CustomPageFilter = {
  comparator: Scalars['String'];
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  value: Scalars['String'];
};

export type CustomPageLayout = {
  columns: Array<CustomPageColumn>;
};

export type CustomPageWidget = {
  config?: Maybe<CustomPageWidgetConfig>;
  type: Scalars['String'];
};

export type CustomPageWidgetConfig = {
  actions?: Maybe<Array<ActionConfig>>;
  backButtonLabel?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  displayContentTypes?: Maybe<Array<Scalars['String']>>;
  displayMode?: Maybe<Scalars['String']>;
  headingContentTypeCode?: Maybe<Scalars['String']>;
  hierarchyId?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  linkContentTypeCode?: Maybe<Scalars['String']>;
  linkedByHierarchyId?: Maybe<Scalars['String']>;
  margin?: Maybe<CustomPageWidgetMargin>;
  maxItems?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['String']>;
  showAddButton?: Maybe<Scalars['Boolean']>;
  showHeading?: Maybe<Scalars['Boolean']>;
  showIcon?: Maybe<Scalars['Boolean']>;
  showLabel?: Maybe<Scalars['Boolean']>;
  showNewButton?: Maybe<Scalars['Boolean']>;
  showSeparator?: Maybe<Scalars['Boolean']>;
  showTitle?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  titleContentTypeCode?: Maybe<Scalars['String']>;
  viewMode?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type CustomPageWidgetMargin = {
  b?: Maybe<Scalars['Float']>;
  l?: Maybe<Scalars['Float']>;
  r?: Maybe<Scalars['Float']>;
  t?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type DiscountMpRoles = {
  max: Scalars['String'];
  min: Scalars['String'];
  role: Scalars['String'];
};

export type DynamicReadonly = {
  dynamicReadonlyRules?: Maybe<Array<DynamicReadonlyRule>>;
  message?: Maybe<Scalars['String']>;
  operator?: Maybe<Scalars['String']>;
};

export type DynamicReadonlyInput = {
  dynamicReadonlyRules?: InputMaybe<Array<DynamicReadonlyRuleInput>>;
  message?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<Scalars['String']>;
};

export type DynamicReadonlyRule = {
  comparator: Scalars['String'];
  id: Scalars['String'];
  option: Scalars['String'];
  value: Scalars['String'];
};

export type DynamicReadonlyRuleInput = {
  comparator: Scalars['String'];
  id: Scalars['String'];
  option: Scalars['String'];
  value: Scalars['String'];
};

export type DynamicRegex = {
  comparator: Scalars['String'];
  id: Scalars['String'];
  option: Scalars['String'];
  regex: Scalars['String'];
  value: Scalars['String'];
};

export type DynamicRegexInput = {
  comparator: Scalars['String'];
  id: Scalars['String'];
  option: Scalars['String'];
  regex: Scalars['String'];
  value: Scalars['String'];
};

export type Edit = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  contentTypeGroupIndex: Scalars['Int'];
  type: Scalars['String'];
  value: Scalars['NodeValue'];
};

export type Exporter = {
  couch: Couch;
  sql: Sql;
};

export type FiammSettings = {
  balanceGoalsHierarchyId: Scalars['String'];
};

export type FieldSetting = {
  contentTypeCode: Scalars['String'];
  defaultValue?: Maybe<Scalars['String']>;
};

export type FieldsSetting = {
  baseProgramField: FieldSetting;
  biasedField: FieldSetting;
  c1Field: FieldSetting;
  c2Field: FieldSetting;
  c3Field: FieldSetting;
  cashDiscountField: FieldSetting;
  certificationStatusField: FieldSetting;
  conquestField: FieldSetting;
  cvaField: FieldSetting;
  dealerDiscountField: FieldSetting;
  denominationField: FieldSetting;
  descriptionField: FieldSetting;
  divisione: FieldSetting;
  extraValueSupportField: FieldSetting;
  familyField: FieldSetting;
  flagUseDN: FieldSetting;
  glBaseMachineField: FieldSetting;
  gpRequestedField: FieldSetting;
  incentiveVolumeField: FieldSetting;
  installedDealerNetField: FieldSetting;
  itemsField: FieldSetting;
  lcField: FieldSetting;
  lineaSapField: FieldSetting;
  marca: FieldSetting;
  marcaField: FieldSetting;
  modelCodeField: FieldSetting;
  nodeTypeField: FieldSetting;
  notInstalledDealerNetField: FieldSetting;
  orderTypeField: FieldSetting;
  priceListField: FieldSetting;
  sapProductHierarchyField: FieldSetting;
  segmento: FieldSetting;
  selectionsField: FieldSetting;
  suffixField: FieldSetting;
  supplierField: FieldSetting;
  supplierNameField: FieldSetting;
  svField: FieldSetting;
  tipo: FieldSetting;
  typeField: FieldSetting;
};

export type Filters = {
  code: Scalars['String'];
  comparator: SearchFilterOperator;
  editable?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  value: Scalars['String'];
};

export type FiltersInput = {
  code: Scalars['String'];
  comparator: Scalars['String'];
  editable: Scalars['Boolean'];
  id: Scalars['String'];
  value: Scalars['String'];
};

export type GlCharacteristic = {
  code: Scalars['String'];
  label: Scalars['String'];
  options: Array<PrototypeGlDataValueGlCharacteristics>;
};

export type GlData = {
  glId: Scalars['String'];
  listPrice: Scalars['String'];
  transportCosts: Scalars['String'];
};

export type GlMediaCategoryMapping = {
  brochure: Scalars['String'];
  image: Scalars['String'];
  other: Scalars['String'];
  technical_drawing: Scalars['String'];
};

export type GlVersionItems = {
  prices: GlVersionItemsPrices;
  versionDate: Scalars['String'];
  versionId: Scalars['String'];
};

export type GlVersionItemsPrices = {
  dn?: Maybe<Scalars['Float']>;
};

export type GlVersionPrices = {
  rows: GlVersionPricesRows;
  versionDate: Scalars['String'];
  versionId: Scalars['String'];
};

export type GlVersionPricesRows = {
  dn?: Maybe<Scalars['Float']>;
  gp?: Maybe<Scalars['Float']>;
  lc?: Maybe<Scalars['Float']>;
  listino?: Maybe<Scalars['Float']>;
  mo?: Maybe<Scalars['Float']>;
  ms?: Maybe<Scalars['Float']>;
  tpa?: Maybe<Scalars['Float']>;
};

export type GlVersions = {
  glCode: Scalars['String'];
  items: Array<GlVersionsItemsData>;
  prices: GlVersionsPriceData;
};

export type GlVersionsItemsData = {
  itemId: Scalars['String'];
  version0?: Maybe<GlVersionItems>;
  version1?: Maybe<GlVersionItems>;
};

export type GlVersionsPriceData = {
  version0?: Maybe<GlVersionPrices>;
  version1?: Maybe<GlVersionPrices>;
};

export type GroupSetting = {
  contentTypeGroupCode: Scalars['String'];
};

export type GroupsSetting = {
  catSupportGroup: GroupSetting;
  cgtSupportGroup: GroupSetting;
  pricingGroup: GroupSetting;
  sapCharacteristicsGroup: GroupSetting;
};

export type HierarchiesSetting = {
  applicationCodeHierarchyId: Scalars['String'];
  cGTModelHierarchyId: Scalars['String'];
  cGTModelUsatoCompetitorHierarchyId: Scalars['String'];
  cadenzaInterventoHierarchyId: Scalars['String'];
  characteristicsCompatibilityRulesHierarchyId: Scalars['String'];
  commercialFamilyHierarchyId: Scalars['String'];
  digitalServiceHierarchyId: Scalars['String'];
  glExFlottaHierarchyId: Scalars['String'];
  glGenericHierarchyId: Scalars['String'];
  glHierarchyId: Scalars['String'];
  glUsatoCompetitorHierarchyId: Scalars['String'];
  linkedGlsCompatibilityRulesHierarchyId: Scalars['String'];
  longListsHierarchyId: Scalars['String'];
  marcheHierarchyId: Scalars['String'];
  mediaHierarchyId: Scalars['String'];
  mmDispoHierarchyId: Scalars['String'];
  priceListHierarchyId: Scalars['String'];
  productWarrantyHierarchyId: Scalars['String'];
  prototypeCompatibilitiesHierarchyId: Scalars['String'];
  sapProductCompetitorHierarchyId: Scalars['String'];
  sapProductHierarchyId: Scalars['String'];
  serviceContractHierarchyId: Scalars['String'];
  serviceModuleAMAListHierarchyId: Scalars['String'];
  serviceModuleHierarchyId: Scalars['String'];
  serviceModuleKitListHierarchyId: Scalars['String'];
  serviceModuleKmListHierarchyId: Scalars['String'];
  sezioniSchedeHierarchyId: Scalars['String'];
  shortListFamiliesExtraCharacteristicsHierarchyId: Scalars['String'];
  shortListFamilyHierarchyId: Scalars['String'];
  shortListsHierarchyId: Scalars['String'];
  supplierHierarchyId: Scalars['String'];
  systemSubSystemHierarchyId: Scalars['String'];
  usagesCompatibilityRulesHierarchyId: Scalars['String'];
  warrantyCgtHierarchyId: Scalars['String'];
  warrantySupplierHierarchyId: Scalars['String'];
};

export type Hierarchy = {
  code: Scalars['String'];
  id: Scalars['String'];
  nodes: Array<HierarchyNode>;
  objectSchema?: Maybe<ObjectSchema>;
  readRoles?: Maybe<Array<Scalars['String']>>;
};


export type HierarchyNodesArgs = {
  filters?: InputMaybe<NodeFilter>;
  isInTranslation?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<Pagination>;
  transformNodes?: InputMaybe<Scalars['Boolean']>;
};

export type HierarchyHistoryEdge = {
  cursor: Scalars['String'];
  node: HierarchyHistoryNode;
};

export type HierarchyHistoryNode = {
  code: Scalars['String'];
  contents: Array<NodeContentO>;
  disabled: Scalars['Boolean'];
  eventId: Scalars['String'];
  eventName: Scalars['String'];
  parent: Scalars['String'];
  timestamp: Scalars['String'];
  user: Scalars['String'];
};

export type HierarchyHistoryResult = {
  edges: Array<HierarchyHistoryEdge>;
  objectSchema: ObjectSchema;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type HierarchyNode = {
  _rev?: Maybe<Scalars['String']>;
  certificationStatus?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  contentTypeGroupStatus?: Maybe<Array<ContentTypeGroupStatus>>;
  contents?: Maybe<Array<NodeContentO>>;
  createdAt: Scalars['Float'];
  disabled?: Maybe<Scalars['Boolean']>;
  hasBeenCertified?: Maybe<Scalars['Boolean']>;
  hasChildren?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  linkedBy?: Maybe<Array<Maybe<LinkedBy>>>;
  listName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  nodePublished: CtgStatus;
  order?: Maybe<Scalars['String']>;
  parent: Scalars['String'];
  parentCode?: Maybe<Scalars['String']>;
  publishedContents?: Maybe<Array<NodeContentO>>;
  readRoles?: Maybe<Array<Scalars['String']>>;
  readUsers?: Maybe<Array<Scalars['String']>>;
  totalChildren?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Float'];
  writeRoles?: Maybe<Array<Scalars['String']>>;
  writeUsers?: Maybe<Array<Scalars['String']>>;
};

export type HintoParams = {
  baseUrl: Scalars['String'];
  xApiKey: Scalars['String'];
};

export type ICompatibilityRuleInput = {
  contents: Array<NodeContent>;
  nodeId: Scalars['String'];
};

export enum ICompatibilityRulesTab {
  IncompatibleCharacteristics = 'IncompatibleCharacteristics',
  IncompatibleUsages = 'IncompatibleUsages',
  LinkedGls = 'LinkedGls'
}

export type IPrototypeCompatibilityInput = {
  contents: Array<NodeContent>;
  nodeId?: InputMaybe<Scalars['String']>;
};

export enum IPublishModelEvent {
  Delete = 'Delete',
  Update = 'Update'
}

export type InvalidGl = {
  code: Scalars['String'];
  id: Scalars['String'];
};

export type IsoCode = {
  approverRole?: Maybe<Scalars['String']>;
  isoCode: Scalars['String'];
  name: Scalars['String'];
  translatorRole?: Maybe<Scalars['String']>;
};

export enum ItemPositionType {
  Mandatory = 'mandatory',
  Merchandise = 'merchandise',
  Optional = 'optional'
}

export type JobFinishedInfo = {
  filename?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type LaneInfoLink = {
  disabled: Scalars['Boolean'];
  id: Scalars['String'];
  installedPrice?: Maybe<Scalars['String']>;
  notInstalledPrice?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};

export type Language = {
  defaultLanguage: Scalars['String'];
  languages: Array<IsoCode>;
};

export type LanguageInput = {
  approverRole?: InputMaybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  isoCode: Scalars['String'];
  name: Scalars['String'];
  translatorRole?: InputMaybe<Scalars['String']>;
};

export type LinkedBy = {
  code: Scalars['String'];
  hierarchyId: Scalars['String'];
  linkedNodes?: Maybe<Array<Maybe<LinkedBy>>>;
  listName?: Maybe<Scalars['String']>;
  nodeId: Scalars['String'];
  order?: Maybe<Scalars['String']>;
};

export type LinkedByHierarchyResult = {
  hierarchyCode: Scalars['String'];
  hierarchyId: Scalars['String'];
  objectSchemaCode: Scalars['String'];
  totalCount: Scalars['Int'];
};

export type LinkedModelGlInfo = {
  c1: Scalars['String'];
  c2: Scalars['String'];
  c3: Scalars['String'];
  deltaPrezzoStandard: Scalars['String'];
  dn: Scalars['String'];
  dnCashD: Scalars['String'];
  gp: Scalars['String'];
  id: Scalars['String'];
  lc: Scalars['String'];
  lcPerc: Scalars['String'];
  listPrice: Scalars['String'];
  listinoForn: Scalars['Boolean'];
  markup: Scalars['String'];
  mo: Scalars['String'];
  modelName: Scalars['String'];
  ms: Scalars['String'];
  status: Scalars['String'];
  tpa: Scalars['String'];
  transportCosts: Scalars['String'];
};

export type MmDispoValidity = {
  errors: Array<PrototypeMmDispoError>;
  prototypeCode: Scalars['String'];
  prototypeId: Scalars['String'];
  values: Array<PrototypeMmDispoValue>;
};

export type MandatoryForSaveCondition = {
  comparator?: Maybe<Scalars['String']>;
  isMandatory?: Maybe<Scalars['Boolean']>;
  option?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MandatoryForSaveConditionInput = {
  comparator?: InputMaybe<Scalars['String']>;
  isMandatory: Scalars['Boolean'];
  option?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Metadata = {
  createdAt?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['BigInt']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type MicrosoftGraphParams = {
  authUrl: Scalars['String'];
  baseUrl: Scalars['String'];
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  scope: Scalars['String'];
};

export type MisalignedGlData = {
  code: Scalars['String'];
  hierarchyId: Scalars['String'];
  items: Array<MisalignedGlDataItem>;
  nodeId: Scalars['String'];
};

export type MisalignedGlDataItem = {
  code: Scalars['String'];
  replacedBy: Scalars['String'];
};

export enum ModelGlStatus {
  Active = 'Active',
  Certificating = 'Certificating',
  CertificationError = 'CertificationError',
  CertificationSuccess = 'CertificationSuccess',
  Error = 'Error',
  MisalignedPrice = 'MisalignedPrice',
  Replaced = 'Replaced',
  StdPriceDelta = 'StdPriceDelta',
  ToCertificate = 'ToCertificate',
  Trasversal = 'Trasversal'
}

export type ModelGlStatusData = {
  data?: Maybe<Array<Scalars['String']>>;
  items?: Maybe<Array<MisalignedGlDataItem>>;
  status: ModelGlStatus;
};

export type ModelGlStatuses = {
  glCode: Scalars['String'];
  glHierarchyId: Scalars['String'];
  glId: Scalars['String'];
  statuses: Array<ModelGlStatusData>;
};

export type Mutation = {
  _empty?: Maybe<Scalars['String']>;
  addContentType?: Maybe<ObjectSchemaMutationResponse>;
  addContentTypeGroup?: Maybe<ObjectSchemaMutationResponse>;
  addLanguage?: Maybe<ObjectSchemaMutationResponse>;
  alignLongLists?: Maybe<ObjectSchemaMutationResponse>;
  alignLonglistsSections?: Maybe<ObjectSchemaMutationResponse>;
  alignMismatchGl?: Maybe<ObjectSchemaMutationResponse>;
  alignModelGls?: Maybe<AlignModelGlsResponse>;
  approveContentTypeGroup?: Maybe<ObjectSchemaMutationResponse>;
  approveLongList: PublishResponse;
  certificateNode?: Maybe<CertificationResponse>;
  certificatePrototype?: Maybe<CertificationResponse>;
  changeGlPriceList?: Maybe<ObjectSchemaMutationResponse>;
  changeLongListCommercialFamily?: Maybe<ObjectSchemaMutationResponse>;
  changeNodesOrder?: Maybe<ObjectSchemaMutationResponse>;
  contentTranslationApproval?: Maybe<Scalars['Boolean']>;
  createHierarchy?: Maybe<ObjectSchemaMutationResponse>;
  createLongList?: Maybe<ObjectSchemaMutationResponse>;
  createNode?: Maybe<ObjectSchemaMutationResponse>;
  createObjectSchema?: Maybe<ObjectSchemaMutationResponse>;
  createPrototype?: Maybe<ObjectSchemaMutationResponse>;
  createShortList?: Maybe<ObjectSchemaMutationResponse>;
  deleteContentType?: Maybe<ObjectSchemaMutationResponse>;
  deleteContentTypeGroup?: Maybe<ObjectSchemaMutationResponse>;
  deleteHierarchy?: Maybe<ObjectSchemaMutationResponse>;
  deleteLanguage?: Maybe<ObjectSchemaMutationResponse>;
  deleteNode?: Maybe<ObjectSchemaMutationResponse>;
  deleteObjectSchema?: Maybe<ObjectSchemaMutationResponse>;
  duplicateHierarchy?: Maybe<ObjectSchemaMutationResponse>;
  duplicateObjectSchema?: Maybe<ObjectSchemaMutationResponse>;
  duplicatePrototype?: Maybe<ObjectSchemaMutationResponse>;
  exportXlsx?: Maybe<Scalars['String']>;
  migrateSidelHierarchyData?: Maybe<ObjectSchemaMutationResponse>;
  migrateSidelProductsData?: Maybe<ObjectSchemaMutationResponse>;
  publish?: Maybe<ObjectSchemaMutationResponse>;
  publishHierarchies?: Maybe<ObjectSchemaMutationResponse>;
  publishLongList: PublishResponse;
  publishModel?: Maybe<CertificationResponse>;
  publishWithRelated?: Maybe<PublishWithRelatedResponse>;
  reorderContentType?: Maybe<ObjectSchemaMutationResponse>;
  reorderContentTypeGroup?: Maybe<ObjectSchemaMutationResponse>;
  replaceItem?: Maybe<ObjectSchemaMutationResponse>;
  saveCompatibilityRules?: Maybe<ObjectSchemaMutationResponse>;
  savePrototypeCompatibility?: Maybe<ObjectSchemaMutationResponse>;
  saveShortListEditableHeaders?: Maybe<ObjectSchemaMutationResponse>;
  saveTrasversalGls?: Maybe<ObjectSchemaMutationResponse>;
  toggleDisabled?: Maybe<ObjectSchemaMutationResponse>;
  toggleFavorite: ToggleFavoriteResponse;
  toggleShortListOpenClose?: Maybe<ObjectSchemaMutationResponse>;
  unpublish?: Maybe<ObjectSchemaMutationResponse>;
  unpublishLongList: PublishResponse;
  updateBulkNodesContents?: Maybe<ObjectSchemaMutationResponse>;
  updateCertificationStatus?: Maybe<ObjectSchemaMutationResponse>;
  updateContentType?: Maybe<ObjectSchemaMutationResponse>;
  updateContentTypeCode?: Maybe<ObjectSchemaMutationResponse>;
  updateContentTypeGroup?: Maybe<ObjectSchemaMutationResponse>;
  updateContentTypeGroupCode?: Maybe<ObjectSchemaMutationResponse>;
  updateHierarchy?: Maybe<ObjectSchemaMutationResponse>;
  updateLanguage?: Maybe<ObjectSchemaMutationResponse>;
  updateListName?: Maybe<Scalars['Boolean']>;
  updateNode?: Maybe<ObjectSchemaMutationResponse>;
  updateNodeContent?: Maybe<ObjectSchemaMutationResponse>;
  updateNodeParent?: Maybe<ObjectSchemaMutationResponse>;
  updateObjectSchema?: Maybe<ObjectSchemaMutationResponse>;
  updatePermissions?: Maybe<ObjectSchemaMutationResponse>;
  updatePrototype?: Maybe<PrototypeUpdateMutationResponse>;
  updateShortList?: Maybe<ObjectSchemaMutationResponse>;
  updateTranslationStatistics?: Maybe<ObjectSchemaMutationResponse>;
};


export type MutationAddContentTypeArgs = {
  aggregateId: Scalars['String'];
  contentType: ContentTypeInput;
  groupCode: Scalars['String'];
};


export type MutationAddContentTypeGroupArgs = {
  aggregateId: Scalars['String'];
  contentTypeGroup: ContentTypeGroupI;
};


export type MutationAddLanguageArgs = {
  language: LanguageInput;
};


export type MutationAlignLongListsArgs = {
  longListIds: Array<Scalars['String']>;
  prototypeId: Scalars['String'];
};


export type MutationAlignLonglistsSectionsArgs = {
  description: Scalars['String'];
  name: Scalars['String'];
  notes: Scalars['String'];
  sectionNodeId: Scalars['String'];
};


export type MutationAlignMismatchGlArgs = {
  modelId: Scalars['String'];
};


export type MutationAlignModelGlsArgs = {
  misalignedGlsIds: Array<Scalars['String']>;
  modelId: Scalars['String'];
};


export type MutationApproveContentTypeGroupArgs = {
  contentTypeGroup?: InputMaybe<Scalars['String']>;
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type MutationApproveLongListArgs = {
  aggregateId: Scalars['String'];
  node: Scalars['String'];
  prototypeId: Scalars['String'];
};


export type MutationCertificateNodeArgs = {
  aggregateId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type MutationCertificatePrototypeArgs = {
  cgtModelVariables: CgtModelVariables;
  prototypeId: Scalars['String'];
};


export type MutationChangeGlPriceListArgs = {
  disabledPriceListId?: InputMaybe<Scalars['String']>;
  glId: Scalars['String'];
  modelId: Scalars['String'];
  priceListId?: InputMaybe<Scalars['String']>;
  priceListIdZMAB?: InputMaybe<Scalars['String']>;
};


export type MutationChangeLongListCommercialFamilyArgs = {
  familyId: Scalars['String'];
  longListId: Scalars['String'];
  longListParent: Scalars['String'];
};


export type MutationChangeNodesOrderArgs = {
  hierarchyId: Scalars['String'];
  nodeOrder: Array<OrderNode>;
  parentId: Scalars['String'];
};


export type MutationContentTranslationApprovalArgs = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  contentTypeGroupIndex: Scalars['Int'];
  hierarchyId: Scalars['String'];
  languageIsoCode: Scalars['String'];
  nodeId: Scalars['String'];
};


export type MutationCreateHierarchyArgs = {
  code: Scalars['String'];
  objectSchema: Scalars['String'];
};


export type MutationCreateLongListArgs = {
  aggregateId: Scalars['String'];
  commercialFamilyId: Scalars['String'];
  commercialFamilyParentId: Scalars['String'];
  prototypeId: Scalars['String'];
};


export type MutationCreateNodeArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
  parent: Scalars['String'];
};


export type MutationCreateObjectSchemaArgs = {
  automaticParentCreation: Scalars['Boolean'];
  bulkPublish: Scalars['Boolean'];
  code: Scalars['String'];
  codeCreationExpression: Scalars['String'];
  codeLabel: Scalars['String'];
  disableDelete: Scalars['Boolean'];
  disableDeleteHierarchy: Scalars['Boolean'];
  disableEditCode: Scalars['Boolean'];
  enablePublish: Scalars['Boolean'];
  listName: Scalars['String'];
  showListNameInEdit: Scalars['Boolean'];
  showPublishInfo: Scalars['Boolean'];
};


export type MutationCreatePrototypeArgs = {
  modelName: Scalars['String'];
  prototypeCode: Scalars['String'];
};


export type MutationCreateShortListArgs = {
  details: ShortListDetails;
};


export type MutationDeleteContentTypeArgs = {
  aggregateId: Scalars['String'];
  contentTypeCode: Scalars['String'];
  groupCode: Scalars['String'];
};


export type MutationDeleteContentTypeGroupArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
};


export type MutationDeleteHierarchyArgs = {
  aggregateId: Scalars['String'];
};


export type MutationDeleteLanguageArgs = {
  isoCode: Scalars['String'];
};


export type MutationDeleteNodeArgs = {
  aggregateId: Scalars['String'];
  node: Scalars['String'];
};


export type MutationDeleteObjectSchemaArgs = {
  aggregateId: Scalars['String'];
};


export type MutationDuplicateHierarchyArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
};


export type MutationDuplicateObjectSchemaArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
};


export type MutationDuplicatePrototypeArgs = {
  contents?: InputMaybe<Array<NodeContent>>;
  modelName: Scalars['String'];
  prototypeCode: Scalars['String'];
  prototypeId: Scalars['String'];
};


export type MutationExportXlsxArgs = {
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  nodeId?: InputMaybe<Scalars['String']>;
  sort: Array<Sort>;
  visibleFields?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationPublishArgs = {
  contentTypeGroups: Array<Scalars['String']>;
  hierarchy: Scalars['String'];
  node: Scalars['String'];
};


export type MutationPublishHierarchiesArgs = {
  hierarchies?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationPublishLongListArgs = {
  aggregateId: Scalars['String'];
  cgtModelId: Scalars['String'];
  nodeId: Scalars['String'];
  prototypeId: Scalars['String'];
  publishedDocumentId: Scalars['String'];
};


export type MutationPublishModelArgs = {
  aggregateId: Scalars['String'];
  event: IPublishModelEvent;
  nodeId: Scalars['String'];
};


export type MutationPublishWithRelatedArgs = {
  targets: Array<PublishTarget>;
};


export type MutationReorderContentTypeArgs = {
  aggregateId: Scalars['String'];
  groupCode: Scalars['String'];
  order: Array<Scalars['String']>;
};


export type MutationReorderContentTypeGroupArgs = {
  aggregateId: Scalars['String'];
  order: Array<Scalars['String']>;
};


export type MutationReplaceItemArgs = {
  newItemCode: Scalars['String'];
  nodeCode: Scalars['String'];
  nodeId: Scalars['String'];
};


export type MutationSaveCompatibilityRulesArgs = {
  aggregateId: Scalars['String'];
  prototypeId: Scalars['String'];
  rules: Array<ICompatibilityRuleInput>;
};


export type MutationSavePrototypeCompatibilityArgs = {
  rules: Array<IPrototypeCompatibilityInput>;
};


export type MutationSaveShortListEditableHeadersArgs = {
  headers: Array<ShortListEditableHeadersInput>;
};


export type MutationSaveTrasversalGlsArgs = {
  glData: Array<GlData>;
  modelIds: Array<Scalars['String']>;
};


export type MutationToggleDisabledArgs = {
  aggregateId: Scalars['String'];
  node: Scalars['String'];
};


export type MutationToggleFavoriteArgs = {
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type MutationToggleShortListOpenCloseArgs = {
  shortListId: Scalars['String'];
};


export type MutationUnpublishArgs = {
  hierarchy: Scalars['String'];
  node: Scalars['String'];
};


export type MutationUnpublishLongListArgs = {
  nodeId: Scalars['String'];
  prototypeId: Scalars['String'];
  publishedDocumentId: Scalars['String'];
};


export type MutationUpdateBulkNodesContentsArgs = {
  aggregateId: Scalars['String'];
  nodes: Array<BulkNodes>;
};


export type MutationUpdateCertificationStatusArgs = {
  aggregateId: Scalars['String'];
  contents: Array<NodeContent>;
  documentVersion?: InputMaybe<Scalars['String']>;
  nodeId: Scalars['String'];
};


export type MutationUpdateContentTypeArgs = {
  aggregateId: Scalars['String'];
  groupCode: Scalars['String'];
  updateContentTypeInput: ContentTypeInput;
};


export type MutationUpdateContentTypeCodeArgs = {
  aggregateId: Scalars['String'];
  groupCode: Scalars['String'];
  newCode: Scalars['String'];
  oldCode: Scalars['String'];
};


export type MutationUpdateContentTypeGroupArgs = {
  aggregateId: Scalars['String'];
  updateContentTypeGroupInput: UpdateContentTypeGroupInput;
};


export type MutationUpdateContentTypeGroupCodeArgs = {
  aggregateId: Scalars['String'];
  newCode: Scalars['String'];
  oldCode: Scalars['String'];
};


export type MutationUpdateHierarchyArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
  objectSchema: Scalars['String'];
};


export type MutationUpdateLanguageArgs = {
  language: LanguageInput;
  oldIsoCode: Scalars['String'];
};


export type MutationUpdateListNameArgs = {
  listName: Scalars['String'];
  objectSchema: Scalars['String'];
};


export type MutationUpdateNodeArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
  node: Scalars['String'];
  parent?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateNodeContentArgs = {
  aggregateId: Scalars['String'];
  contents: Array<NodeContent>;
  isCreate?: InputMaybe<Scalars['Boolean']>;
  node: Scalars['String'];
  parent?: InputMaybe<Scalars['String']>;
  skipTranslation: Scalars['Boolean'];
};


export type MutationUpdateNodeParentArgs = {
  aggregateId: Scalars['String'];
  node: Scalars['String'];
  parent: Scalars['String'];
};


export type MutationUpdateObjectSchemaArgs = {
  aggregateId: Scalars['String'];
  automaticParentCreation: Scalars['Boolean'];
  bulkPublish: Scalars['Boolean'];
  code: Scalars['String'];
  codeCreationExpression: Scalars['String'];
  codeLabel: Scalars['String'];
  disableDelete: Scalars['Boolean'];
  disableDeleteHierarchy: Scalars['Boolean'];
  disableEditCode: Scalars['Boolean'];
  enablePublish: Scalars['Boolean'];
  listName: Scalars['String'];
  showListNameInEdit: Scalars['Boolean'];
  showPublishInfo: Scalars['Boolean'];
};


export type MutationUpdatePermissionsArgs = {
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
  readRoles: Array<Scalars['String']>;
  readUsers: Array<Scalars['String']>;
  writeRoles: Array<Scalars['String']>;
  writeUsers: Array<Scalars['String']>;
};


export type MutationUpdatePrototypeArgs = {
  contents: Array<NodeContent>;
  node: Scalars['String'];
  skipTranslation: Scalars['Boolean'];
};


export type MutationUpdateShortListArgs = {
  columns: Scalars['String'];
  familyNodeId?: InputMaybe<Scalars['String']>;
  legend: Array<ShortListLegendItemInput>;
  prototypesNodesIds: Array<Scalars['String']>;
  shortListFamilyNodeId: Scalars['String'];
  shortListNodeId: Scalars['String'];
};


export type MutationUpdateTranslationStatisticsArgs = {
  keptAsReceivedCount: Scalars['Int'];
  modifiedCount: Scalars['Int'];
};

export type NameObject = {
  languageIsoCode: Scalars['String'];
  value: Scalars['String'];
};

export type NameObjectI = {
  languageIsoCode: Scalars['String'];
  value: Scalars['String'];
};

export type NodeContent = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  contentTypeGroupIndex: Scalars['Int'];
  hierarchy?: InputMaybe<Scalars['String']>;
  inherited?: InputMaybe<Scalars['Boolean']>;
  repeatable: Scalars['Boolean'];
  type: Scalars['String'];
  value: Array<NodeContentValue>;
};

export type NodeContentFilter = {
  contentType?: InputMaybe<Scalars['String']>;
  contentTypeGroup?: InputMaybe<Scalars['String']>;
  strictCheck?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type NodeContentO = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  contentTypeGroupIndex: Scalars['Int'];
  inherited: Scalars['Boolean'];
  repeatable?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  value?: Maybe<Array<NodeContentValueO>>;
};

export type NodeContentValue = {
  approvedValue?: InputMaybe<Array<Scalars['NodeValue']>>;
  autoGenerated?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  languageIsoCode: Scalars['String'];
  measure?: InputMaybe<Scalars['String']>;
  translate?: InputMaybe<Scalars['Boolean']>;
  translating?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['NodeValue']>;
};

export type NodeContentValueO = {
  approvedValue?: Maybe<Array<Maybe<Scalars['NodeValue']>>>;
  autoGenerated?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  languageIsoCode: Scalars['String'];
  measure?: Maybe<Scalars['String']>;
  translate?: Maybe<Scalars['Boolean']>;
  translating?: Maybe<Scalars['Boolean']>;
  value: Array<Maybe<Scalars['NodeValue']>>;
};

export type NodeFilter = {
  code?: InputMaybe<Scalars['String']>;
  contentFilters?: InputMaybe<Array<NodeContentFilter>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  parent?: InputMaybe<Scalars['String']>;
};

export type NodeResult = {
  count: Scalars['Int'];
  edges: Array<SearchNodeEdge>;
  pageInfo: PageInfo;
};

export type ObjectSchema = {
  automaticParentCreation?: Maybe<Scalars['Boolean']>;
  bulkPublish?: Maybe<Scalars['Boolean']>;
  code: Scalars['String'];
  codeCreationExpression?: Maybe<Scalars['String']>;
  codeLabel?: Maybe<Scalars['String']>;
  contentTypeGroups?: Maybe<Array<ContentTypeGroup>>;
  disableDelete?: Maybe<Scalars['Boolean']>;
  disableDeleteHierarchy?: Maybe<Scalars['Boolean']>;
  disableEditCode?: Maybe<Scalars['Boolean']>;
  enablePublish?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isReferenced: Scalars['Boolean'];
  listName?: Maybe<Scalars['String']>;
  showListNameInEdit?: Maybe<Scalars['Boolean']>;
  showPublishInfo?: Maybe<Scalars['Boolean']>;
};

export type ObjectSchemaMutationResponse = {
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ObjectSchemasMetadata = {
  shortListFamilyId?: InputMaybe<Scalars['String']>;
};

export type ObjectSchemasSetting = {
  cgtModelHierarchyObjectSchemaId: Scalars['String'];
  digitalServiceObjectSchemaId: Scalars['String'];
  glHierarchyObjectSchemaId: Scalars['String'];
  longListsHierarchyObjectSchemaId: Scalars['String'];
  prototypeHierarchyObjectSchemaId: Scalars['String'];
  sapProductHierarchyObjectSchemaId: Scalars['String'];
  shortListFamiliesExtraCharacteristicsObjectSchemaId: Scalars['String'];
  shortListFamilyHierarchyObjectSchemaId: Scalars['String'];
};

export type OptionValue = {
  languageIsoCode: Scalars['String'];
  value: Scalars['String'];
};

export type OptionValueInput = {
  languageIsoCode: Scalars['String'];
  value: Scalars['String'];
};

export type OptionWarning = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  warningMessage: Scalars['String'];
};

export type OrderNode = {
  nodeId: Scalars['String'];
  order: Scalars['Int'];
};

export type OriginNode = {
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};

export type PageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
};

export type Pagination = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type PathsSetting = {
  accessories: Scalars['String'];
  baseMachine: Scalars['String'];
  itemsValue: Scalars['String'];
  priceListValue: Scalars['String'];
  primaryPriceListValue: Scalars['String'];
  sapProductHierarchyValue: Scalars['String'];
  secondaryPriceListValue: Scalars['String'];
};

export type PimPricingHierarchies = {
  priceLists: Scalars['String'];
};

export type PimPricingSettings = {
  enable: Scalars['Boolean'];
  hierarchies: PimPricingHierarchies;
};

export type Price = {
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type PriceListInfo = {
  id: Scalars['String'];
  listName: Scalars['String'];
};

export type PriceListRecap = {
  currentNode?: Maybe<SearchNode>;
  nodes: NodeResult;
};

export type PriceSetting = {
  dealer_gp: Price;
  dealer_ms: Price;
  dealer_price: Price;
  dn: Price;
  dnWithDelta: Price;
  dn_cash_d: Price;
  extra_discount: Price;
  forced_dealer_gp: Price;
  forced_dealer_price: Price;
  forced_gp: Price;
  forced_tpa: Price;
  forced_vn: Price;
  gl_list_price: Price;
  gl_tpa: Price;
  gp: Price;
  gp_ms: Price;
  gp_tpa: Price;
  lc: Price;
  list_price: Price;
  markup: Price;
  mo: Price;
  ms: Price;
  standard_price_delta: Price;
  tpa: Price;
  transport_costs: Price;
};

export type ProductInfoMutationType = {
  code: Scalars['String'];
  contentTypeGroups: Array<ContentTypeGroup>;
  id: Scalars['String'];
};

export type Prototype = {
  contentTypes: PrototypeContentTypes;
  enable: Scalars['Boolean'];
  hierarchies?: Maybe<PrototypeHierarchies>;
};

export type PrototypeCertifications = {
  date: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  user: Scalars['String'];
};

export type PrototypeContentType = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
};

export type PrototypeContentTypes = {
  configuratorApiKey?: Maybe<PrototypeContentType>;
  configuratorBaseUrl?: Maybe<PrototypeContentType>;
  configuratorPackagePath?: Maybe<PrototypeContentType>;
  configuratorType?: Maybe<PrototypeContentType>;
  configuratorViewId?: Maybe<PrototypeContentType>;
  modelImage?: Maybe<PrototypeContentType>;
  modelOptions: Array<PrototypeContentType>;
  optionCost?: Maybe<PrototypeContentType>;
  optionPrice?: Maybe<PrototypeContentType>;
  optionWarning?: Maybe<OptionWarning>;
  prototypeOptions?: Maybe<PrototypeContentType>;
};

export type PrototypeGlData = {
  link: Scalars['String'];
  value: PrototypeGlDataValue;
};

export type PrototypeGlDataValue = {
  code: Scalars['String'];
  dealerGpWithSupports?: Maybe<Scalars['Int']>;
  dealer_gp?: Maybe<Scalars['Int']>;
  dealer_ms?: Maybe<Scalars['Int']>;
  dealer_price?: Maybe<Scalars['Int']>;
  denomination?: Maybe<Scalars['String']>;
  dn?: Maybe<Scalars['Int']>;
  dnCashDWithSupports?: Maybe<Scalars['Int']>;
  dnWithDelta?: Maybe<Scalars['Int']>;
  dnWithSupports?: Maybe<Scalars['Int']>;
  dn_cash_d?: Maybe<Scalars['Int']>;
  family?: Maybe<Scalars['String']>;
  forcedListPrice?: Maybe<Scalars['Int']>;
  glCode: Scalars['String'];
  gl_characteristics?: Maybe<Array<PrototypeGlDataValueGlCharacteristics>>;
  gl_list_price?: Maybe<Scalars['Int']>;
  gl_tpa?: Maybe<Scalars['Int']>;
  gp?: Maybe<Scalars['Int']>;
  gpWithSupports?: Maybe<Scalars['Int']>;
  lc?: Maybe<Scalars['Int']>;
  lcWithSupports?: Maybe<Scalars['Int']>;
  list_price?: Maybe<Scalars['Int']>;
  markup?: Maybe<Scalars['Int']>;
  markupWithSupports?: Maybe<Scalars['Int']>;
  mo?: Maybe<Scalars['Int']>;
  ms?: Maybe<Scalars['Int']>;
  selection?: Maybe<Scalars['Int']>;
  standard_price_delta?: Maybe<Scalars['Int']>;
  tpa?: Maybe<Scalars['Int']>;
  transport_costs?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type PrototypeGlDataValueGlCharacteristics = {
  code: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type PrototypeHierarchies = {
  configurationRules?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  prototype: Scalars['String'];
  prototypeCompatibilities?: Maybe<Scalars['String']>;
};

export type PrototypeMmDispoError = {
  gls: Array<PrototypeMmDispoGl>;
  position: Scalars['String'];
};

export type PrototypeMmDispoGl = {
  code: Scalars['String'];
  id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PrototypeMmDispoValue = {
  gl?: Maybe<PrototypeMmDispoGl>;
  position: Scalars['String'];
};

export type PrototypeMediaCategoryMapping = {
  brochure: Scalars['String'];
  image: Scalars['String'];
  other: Scalars['String'];
};

export type PrototypeSetting = {
  certificationStatuses: CertificationStatus;
  glCodes: Array<Scalars['String']>;
  modelCode: Scalars['String'];
  objectSchemaCode: Scalars['String'];
  priceCodes: PriceSetting;
  prototypeHierarchyId: Scalars['String'];
};

export type PrototypeUpdateMutationResponse = {
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type PublishNodeResult = {
  hierarchyId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  nodeId: Scalars['String'];
  success: Scalars['Boolean'];
};

export type PublishResponse = {
  success: Scalars['Boolean'];
};

export type PublishTarget = {
  contentTypeGroups: Array<Scalars['String']>;
  hierarchy: Scalars['String'];
  node: Scalars['String'];
};

export type PublishWithRelatedResponse = {
  results: Array<PublishNodeResult>;
  success: Scalars['Boolean'];
};

export type PublishedContentTypeGroup = {
  contentTypeGroup: Scalars['String'];
  contents: Array<NodeContentO>;
};

export type PublishedNode = {
  code: Scalars['String'];
  disabled: Scalars['Boolean'];
  id: Scalars['String'];
  nodeId: Scalars['String'];
  parent: Scalars['String'];
  publishedAt: Scalars['String'];
  updatedBy: Scalars['String'];
  version: Scalars['Int'];
  withdrawn?: Maybe<Scalars['Boolean']>;
};

export type PublishedNodeContent = {
  contentTypeGroups: Array<PublishedContentTypeGroup>;
  updatedAt: Scalars['String'];
  updatedBy: Scalars['String'];
};

export type Query = {
  _empty?: Maybe<Scalars['String']>;
  breadcrumb: Array<BreadcrumbNode>;
  contentTranslation: Scalars['String'];
  contentType?: Maybe<ContentType>;
  contentTypeGroup?: Maybe<ContentTypeGroup>;
  getCompatibilityRulesGlAndDigitalServices: SearchResult;
  getCompatibilityRulesGlAndDigitalServicesObjectschemas: Array<ObjectSchema>;
  getCompatiblePriceLists: CompatiblePriceList;
  getLinkedByHierarchies: Array<LinkedByHierarchyResult>;
  getMatchingLongLists: SearchResult;
  getNodeIdByCode?: Maybe<Scalars['String']>;
  getPrototypeCertifications: Array<PrototypeCertifications>;
  getPrototypeGlVersions: GlVersions;
  getPrototypes: Array<HierarchyNode>;
  getPrototypesMMDispoValidity: Array<MmDispoValidity>;
  getPrototypesSearchData: SearchResult;
  getPrototypesSearchDataObjectSchemas: Array<ObjectSchema>;
  getPublishedContent: PublishedNodeContent;
  getPublishedNodeVersions: Array<PublishedNode>;
  getRelatedUnpublishedNodes: Array<RelatedUnpublishedNode>;
  getSelectedDgs: Array<SelectedDgs>;
  getSelectedGls: Array<SelectedGl>;
  getShortListBuildupDiff: Array<BuildUpDiff>;
  getShortListEditableHeaders: ShortListEditableHeaders;
  getShortlistSAPLegend: Array<ShortlistSapLegendItem>;
  getShortlistsObjectschemas: Array<ObjectSchema>;
  getShortlistsPrototypes: SearchResult;
  glCharacteristics: Array<GlCharacteristic>;
  glItems: CheckResponse;
  glLinkedModelsInfo: Array<LinkedModelGlInfo>;
  glMismatch: Array<Scalars['String']>;
  hierarchies?: Maybe<Array<Hierarchy>>;
  hierarchyHistory: HierarchyHistoryResult;
  inheritAncestorNode: Scalars['String'];
  invalidGls: Array<InvalidGl>;
  isFavorite: Scalars['Boolean'];
  languages?: Maybe<Array<Language>>;
  modelGlsStatuses: Array<ModelGlStatuses>;
  modelHasDisabledItems: Scalars['Boolean'];
  nodeList: SearchResult;
  objectSchemas: Array<ObjectSchema>;
  priceListRecap: PriceListRecap;
  priceListRecapObjectSchemas: Array<ObjectSchema>;
  prices: Array<Price>;
  prototypeCount: Scalars['Int'];
  searchHierarchies: SearchResult;
  settings: Setting;
};


export type QueryBreadcrumbArgs = {
  hierarchyId?: InputMaybe<Scalars['String']>;
  nodeId?: InputMaybe<Scalars['String']>;
};


export type QueryContentTranslationArgs = {
  content: Scalars['String'];
  fromIsoCode: Scalars['String'];
  toIsoCode: Scalars['String'];
  type: Scalars['String'];
};


export type QueryContentTypeArgs = {
  aggregateId: Scalars['String'];
  fieldCode: Scalars['String'];
  groupCode: Scalars['String'];
};


export type QueryContentTypeGroupArgs = {
  aggregateId: Scalars['String'];
  code: Scalars['String'];
};


export type QueryGetCompatibilityRulesGlAndDigitalServicesArgs = {
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  pagination: Pagination;
  sort: Array<Sort>;
};


export type QueryGetCompatiblePriceListsArgs = {
  glId: Scalars['String'];
  modelId: Scalars['String'];
};


export type QueryGetLinkedByHierarchiesArgs = {
  depth?: InputMaybe<Scalars['String']>;
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type QueryGetMatchingLongListsArgs = {
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  pagination: Pagination;
  sort: Array<Sort>;
};


export type QueryGetNodeIdByCodeArgs = {
  hierarchyId: Scalars['String'];
  nodeCode: Scalars['String'];
};


export type QueryGetPrototypeCertificationsArgs = {
  prototypeId: Scalars['String'];
};


export type QueryGetPrototypeGlVersionsArgs = {
  certificationIds: Array<Scalars['String']>;
  glId: Scalars['String'];
};


export type QueryGetPrototypesArgs = {
  modelId: Scalars['String'];
};


export type QueryGetPrototypesMmDispoValidityArgs = {
  modelId: Scalars['String'];
};


export type QueryGetPrototypesSearchDataArgs = {
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  pagination: Pagination;
  sort: Array<Sort>;
};


export type QueryGetPrototypesSearchDataObjectSchemasArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetPublishedContentArgs = {
  contentTypeGroup?: InputMaybe<Scalars['String']>;
  hierarchy: Scalars['String'];
  node: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
};


export type QueryGetPublishedNodeVersionsArgs = {
  hierarchyId: Scalars['String'];
  nodeIds: Array<Scalars['String']>;
};


export type QueryGetRelatedUnpublishedNodesArgs = {
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type QueryGetSelectedDgsArgs = {
  dgsIds: Array<Scalars['String']>;
  modelId: Scalars['String'];
};


export type QueryGetSelectedGlsArgs = {
  glIds: Array<Scalars['String']>;
  modelId: Scalars['String'];
};


export type QueryGetShortListBuildupDiffArgs = {
  shortListId: Scalars['String'];
};


export type QueryGetShortListEditableHeadersArgs = {
  shortlistFamilyId: Scalars['String'];
};


export type QueryGetShortlistSapLegendArgs = {
  familyId: Scalars['String'];
};


export type QueryGetShortlistsObjectschemasArgs = {
  metadata?: InputMaybe<ObjectSchemasMetadata>;
};


export type QueryGetShortlistsPrototypesArgs = {
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  pagination: Pagination;
  sort: Array<Sort>;
};


export type QueryGlItemsArgs = {
  glNodeId?: InputMaybe<Scalars['String']>;
  glType: Scalars['String'];
  itemValues?: InputMaybe<Array<Scalars['NodeValue']>>;
  modelId: Scalars['String'];
};


export type QueryGlLinkedModelsInfoArgs = {
  glId: Scalars['String'];
  modelId: Scalars['String'];
};


export type QueryGlMismatchArgs = {
  priceListId: Scalars['String'];
};


export type QueryHierarchiesArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryHierarchyHistoryArgs = {
  hierarchy: Scalars['String'];
  node: Scalars['String'];
  pagination: Pagination;
};


export type QueryInheritAncestorNodeArgs = {
  contentType: Scalars['String'];
  contentTypeGroup: Scalars['String'];
  contentTypeGroupIndex: Scalars['Int'];
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type QueryInvalidGlsArgs = {
  modelId: Scalars['String'];
  priceListId: Scalars['String'];
};


export type QueryIsFavoriteArgs = {
  hierarchyId: Scalars['String'];
  nodeId: Scalars['String'];
};


export type QueryLanguagesArgs = {
  isoCode?: InputMaybe<Scalars['String']>;
};


export type QueryModelGlsStatusesArgs = {
  modelId: Scalars['String'];
};


export type QueryModelHasDisabledItemsArgs = {
  modelId: Scalars['String'];
};


export type QueryNodeListArgs = {
  filter: Array<SearchFilter>;
  id?: InputMaybe<Scalars['String']>;
  isInTranslation?: InputMaybe<Scalars['Boolean']>;
  nodeId?: InputMaybe<Scalars['String']>;
  pagination: Pagination;
  withBreadcrumbs?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPriceListRecapArgs = {
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  originHierarchyId?: InputMaybe<Scalars['String']>;
  pagination: Pagination;
  sort: Array<Sort>;
};


export type QueryPriceListRecapObjectSchemasArgs = {
  metadata?: InputMaybe<ObjectSchemasMetadata>;
};


export type QueryPricesArgs = {
  contentTypeGroupCode: Scalars['String'];
  hierarchyId: Scalars['String'];
};


export type QueryPrototypeCountArgs = {
  modelId: Scalars['String'];
};


export type QuerySearchHierarchiesArgs = {
  disableNodesTransformation?: InputMaybe<Scalars['Boolean']>;
  filter: Array<SearchFilter>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  originNode?: InputMaybe<OriginNode>;
  pagination: Pagination;
  sort: Array<Sort>;
};

export type RelatedUnpublishedNode = {
  code: Scalars['String'];
  contentTypeGroupStatus?: Maybe<Array<ContentTypeGroupStatus>>;
  hierarchyCode: Scalars['String'];
  hierarchyId: Scalars['String'];
  listName?: Maybe<Scalars['String']>;
  nodeId: Scalars['String'];
  nodePublished: CtgStatus;
};

export type SearchDataPagination = {
  defaultPageSize: Scalars['Int'];
  pageSizes: Array<Scalars['Int']>;
};

export type SearchFilter = {
  field: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  linkedHierarchy?: InputMaybe<Scalars['String']>;
  operator: SearchFilterOperator;
  value: Array<Scalars['String']>;
};

export enum SearchFilterOperator {
  Contains = 'contains',
  EndsWith = 'endsWith',
  Equals = 'equals',
  ExactMatch = 'exactMatch',
  GreaterThan = 'greaterThan',
  GreaterThanEqual = 'greaterThanEqual',
  Includes = 'includes',
  IsAnyOf = 'isAnyOf',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',
  LessThan = 'lessThan',
  LessThanEqual = 'lessThanEqual',
  NotEquals = 'notEquals',
  StartsWith = 'startsWith'
}

export type SearchNode = {
  _rev?: Maybe<Scalars['String']>;
  breadcrumb?: Maybe<Array<BreadcrumbNode>>;
  code: Scalars['String'];
  contentTypeGroupStatus?: Maybe<Array<ContentTypeGroupStatus>>;
  contents: Array<NodeContentO>;
  createdAt: Scalars['Float'];
  depth?: Maybe<Scalars['Int']>;
  disabled: Scalars['Boolean'];
  firstNodeStatus?: Maybe<Scalars['String']>;
  hierarchy: Scalars['String'];
  hierarchyCode: Scalars['String'];
  id: Scalars['String'];
  linkedBy?: Maybe<Array<Maybe<LinkedBy>>>;
  listName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  nodePublished: CtgStatus;
  order?: Maybe<Scalars['String']>;
  parent: Scalars['String'];
  parentCode: Scalars['String'];
  readRoles?: Maybe<Array<Scalars['String']>>;
  readUsers?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['Float'];
  writeRoles?: Maybe<Array<Scalars['String']>>;
  writeUsers?: Maybe<Array<Scalars['String']>>;
};

export type SearchNodeEdge = {
  cursor: Scalars['String'];
  node: SearchNode;
};

export type SearchResult = {
  bulkPublish?: Maybe<Scalars['Boolean']>;
  currentNode?: Maybe<SearchNode>;
  enablePublish?: Maybe<Scalars['Boolean']>;
  nodes: NodeResult;
  showPublishInfo?: Maybe<Scalars['Boolean']>;
};

export type SelectOptionValues = {
  code: Scalars['String'];
  value: Array<OptionValue>;
};

export type SelectOptionValuesInput = {
  code: Scalars['String'];
  value: Array<OptionValueInput>;
};

export type SelectedDgs = {
  base_unit: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  hierarchyId: Scalars['String'];
  id: Scalars['String'];
  list_price: Scalars['String'];
  material: Scalars['String'];
};

export type SelectedGl = {
  code: Scalars['String'];
  denomination: Scalars['String'];
  description: Scalars['String'];
  family: Scalars['String'];
  hierarchyId: Scalars['String'];
  id: Scalars['String'];
  items: Array<SelectedGlItem>;
  type: Scalars['String'];
};

export type SelectedGlItem = {
  id: Scalars['String'];
  positionType: ItemPositionType;
  quantity: Scalars['String'];
};

export type Setting = {
  cgtSettings?: Maybe<CgtSettings>;
  cpq?: Maybe<CpqSettings>;
  crm?: Maybe<CrmSettings>;
  customPages?: Maybe<Array<CustomPage>>;
  enableAI: Scalars['Boolean'];
  enableContentTranslation: Scalars['Boolean'];
  enableExternalSystemRequestLogger?: Maybe<Scalars['Boolean']>;
  enableSearch: Scalars['Boolean'];
  fiammSettings?: Maybe<FiammSettings>;
  jobList?: Maybe<Array<Scalars['String']>>;
  pimPricing?: Maybe<PimPricingSettings>;
  prototype?: Maybe<Prototype>;
  searchDataPagination?: Maybe<SearchDataPagination>;
  sidelSettings?: Maybe<SidelSettings>;
  theme?: Maybe<ThemeSetting>;
  trackPublishedDocuments?: Maybe<Scalars['Boolean']>;
};

export type ShortListDetails = {
  color: Scalars['String'];
  endValidityDate: Scalars['String'];
  month: Scalars['String'];
  name: Scalars['String'];
  preset: Scalars['String'];
  segment: Scalars['String'];
  startValidityDate: Scalars['String'];
  year: Scalars['String'];
};

export type ShortListEditableHeaderEntry = {
  alias: Scalars['String'];
  code: Scalars['String'];
  label: Scalars['String'];
};

export type ShortListEditableHeaders = {
  all: Array<ShortListEditableHeaderEntry>;
  current: Array<ShortListEditableHeaderEntry>;
};

export type ShortListEditableHeadersInput = {
  alias: Scalars['String'];
  code: Scalars['String'];
};

export type ShortListLegendItemInput = {
  code: Scalars['String'];
  hideInExport: Scalars['Boolean'];
  value: Scalars['String'];
};

export type ShortlistSapLegendItem = {
  code: Scalars['String'];
  hideInExport: Scalars['Boolean'];
  isMMDispo?: Maybe<Scalars['Boolean']>;
  isSaved?: Maybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type SidelSettings = {
  boomi?: Maybe<SidelSettingsBoomi>;
  hierarchies?: Maybe<SidelSettingsHierarchy>;
};

export type SidelSettingsBoomi = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type SidelSettingsHierarchy = {
  commercialItems: Scalars['String'];
  massiveCheckPrefix?: Maybe<Scalars['String']>;
};

export type Sort = {
  field: Scalars['String'];
  sort: SortOrder;
  type?: InputMaybe<Scalars['String']>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Sql = {
  database: Scalars['String'];
  host: Scalars['String'];
  password: Scalars['String'];
  port?: Maybe<Scalars['Int']>;
  table?: Maybe<Scalars['String']>;
  user: Scalars['String'];
};

export type Subscription = {
  eventCreated: SubscriptionEvent;
  jobFinished: JobFinishedInfo;
};


export type SubscriptionEventCreatedArgs = {
  hierarchyId?: InputMaybe<Scalars['String']>;
  nodeId?: InputMaybe<Scalars['String']>;
};


export type SubscriptionJobFinishedArgs = {
  company?: InputMaybe<Scalars['String']>;
  jobId?: InputMaybe<Scalars['String']>;
};

export type SubscriptionEvent = {
  edits: Array<Edit>;
};

export type ThemeSetting = {
  logo?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
};

export type ToggleFavoriteResponse = {
  isFavorite: Scalars['Boolean'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Visibility = {
  operator?: Maybe<Scalars['String']>;
  visibilityRules?: Maybe<Array<VisibilityRule>>;
};

export type VisibilityInput = {
  operator: Scalars['String'];
  visibilityRules?: InputMaybe<Array<VisibilityRuleInput>>;
};

export type VisibilityRule = {
  comparator: Scalars['String'];
  id: Scalars['String'];
  option: Scalars['String'];
  value: Scalars['String'];
};

export type VisibilityRuleInput = {
  comparator: Scalars['String'];
  id: Scalars['String'];
  option: Scalars['String'];
  value: Scalars['String'];
};

export type UpdateContentTypeGroupInput = {
  approveRoles?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  collapsed: Scalars['Boolean'];
  name: Array<NameObjectI>;
  repeatable: Scalars['Boolean'];
  roles?: InputMaybe<Scalars['String']>;
  showLevel?: InputMaybe<Scalars['String']>;
  viewRoles?: InputMaybe<Array<Scalars['String']>>;
};
